import { Component, OnInit, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { EventService } from "../../services/event.service";
import { EmitterService } from "../../services/emitter.service";
import { IEvent } from "../../interfaces/ievent";
import { IButton } from "../../interfaces/ibuttons";
import { IDisable } from "../../interfaces/idisable";
import { DisableItemsFilterPipe } from "../../pipes/disableitemsfilter.pipe";
import { HeaderComponent } from "../header/header.component";

/**
 * Events component
 */
@Component({
    selector: "events",
    standalone: true,
    imports: [CommonModule, FormsModule, RouterModule, HeaderComponent],
    providers: [DisableItemsFilterPipe],
    templateUrl: "./events.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class EventsComponent implements OnInit {
    events: IEvent[];
    allEvents: IEvent[];
    headerButtons: IButton[];
    title: string = "Timeline";
    headingClass = "navigation__link-icon fa fa-circle-o";
    hideDisableEvents = true;

    constructor(private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
        private eventService: EventService,
        private togglePipe: DisableItemsFilterPipe,
        private router: Router) {
        let emitter: EventEmitter<any> = EmitterService.get("Create event");
        let button: IButton = { label: "Create event", btnClass: "fa fa-plus ml-2", btnClicked: emitter, disable: false };
        this.headerButtons = [button];

        emitter.subscribe(() => { this.addEvent(); });
   }

    /**
     * On initailse of an events component.
     * Here it fetches the events data to display.
     */
    ngOnInit(): void {
        this.allEvents = this.activatedRoute.snapshot.data["events"];
        this.events = this.allEvents.filter(e => !(e as IDisable).disabled);
        this.title = this.activatedRoute.snapshot.data['title'];
    }

    /**
     * Add Event button clicked.
     * It navigates to a create event page.
     */
    addEvent(): void {
        this.router.navigate(["/event"]);
    }

    /**
     * Edit Event button clicked.
     * It navigates to a udpate event page.
     */
    editEvent(event: IEvent): void {
        this.router.navigate(["/event", event.id]);
    }

    /**
     * Show or hide the disabled events from the screen.
     */
    showHideDisableEvents(): void {
        this.hideDisableEvents = !this.hideDisableEvents;
        this.events = this.togglePipe.transform(this.hideDisableEvents, this.allEvents) as IEvent[];
    }
}

